import { useRecoilValue } from 'recoil'
import useDebounce from 'shared/hooks/useDebounce'
import { useCallback } from 'react'
import useItemsSetter from 'recoil/useItemsSetter'
import useTableWithRequest from 'shared/Table/useTableWithRequest'
import Table from 'shared/Table'
import gradeTableFields from './gradeTable.fields'
import gradeTableAtom from './grade.atom'
import { IGrade } from 'screens/Protection/protection.types'
import protectionsApi from 'screens/Protection/protection.api'
import { useNavigate } from 'react-router-dom'

const GradeTable = () => {
  const state = useRecoilValue(gradeTableAtom)
  const itemsSetter = useItemsSetter(gradeTableAtom)
  const debouncedSearch = useDebounce(state.filters.search, 400)
  const navigate = useNavigate()

  const fetcher = useCallback(
    (params: Record<string, any>) => {
      return protectionsApi.listGrade({
        search: debouncedSearch,
        roomIds: state.filters.roomId,
        expertIds: state.filters.expertIds?.length ? state.filters.expertIds.map((exp) => exp.value) : undefined,
        ...params,
      })
    },
    [debouncedSearch, state.filters.roomId, state.filters.expertIds]
  )

  const tableCtrl = useTableWithRequest<IGrade>({
    dataFetcher: fetcher,
    fields: gradeTableFields,
    itemKey: 'id',
    items: state.items,
    setItems: itemsSetter,
    tableKey: 'grade',
  })

  const handleClick = useCallback((val: IGrade) => {
    navigate(`/protections/${val.defenceId}/team/${val.team?.id}`)
  }, [])

  return (
    <Table
      {...tableCtrl}
      items={tableCtrl.orderedItems}
      handleSelect={tableCtrl.selectedCtrl.setSelected}
      selected={tableCtrl.selectedCtrl.selectedIndexes as Set<keyof IGrade>}
      handleSelectAll={tableCtrl.selectedCtrl.setSelectAll}
      itemKey='id'
      onCLick={handleClick}
    />
  )
}

export default GradeTable
